/* eslint-disable no-fallthrough */
/* eslint-disable import/no-anonymous-default-export */
import {
    SET_COUNTRY_DATA,
    SET_ALL_STATE_DATA,
    SET_ALL_CITY_DATA,
    SET_ALL_PIN_CODE_DATA,
    SET_SELECTED_STATE_DATA,
    SET_SELECTED_CITY_DATA,
    SET_COUNTRY_REPORT_DATA,
    SET_REPORT_DEALER_DATA,
    SET_CONTRACTOR_REPORT_DATA,
    SET_EXCEL_REPORT,
    SET_REPORT_VALIDATION,
    SET_INTERVAL_ID,
    SET_CERTIFICATE_DATA,
    SET_CERTIFICATE_NAME,
    SET_SEARCH_CERTIFICATE_DATA,
    SET_LOADER_FLAG
} from './types'

const initialState = {
    loader: false,
    reportValidation: false,
    intervalData: { intervalId: 0, entity: "" },
    excelReport: {},
    countryData: {},
    allStateData: [],
    allCityData: [],
    allPinCodeData: [],
    countryReportData: {},
    selectedStateData: {},
    selectedCityData: {},
    dealerWiseData: {},
    certificatesData: {},
    certificateName: {},
    searchedCertificateData: {},
    contractorWiseData: { child: {}, associate: {} }
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_REPORT_VALIDATION:
            return {
                ...state,
                reportValidation: payload
            }

        case SET_INTERVAL_ID:
            return {
                ...state,
                intervalData: payload
            }

        case SET_EXCEL_REPORT:
            return {
                ...state,
                excelReport: payload
            }

        case SET_COUNTRY_DATA:
            return {
                ...state,
                countryData: payload
            }

        case SET_ALL_STATE_DATA:
            return {
                ...state,
                allStateData: payload
            }

        case SET_ALL_CITY_DATA:
            return {
                ...state,
                allCityData: payload
            }

        case SET_ALL_PIN_CODE_DATA:
            return {
                ...state,
                allPinCodeData: payload
            }

        case SET_SELECTED_STATE_DATA:
            return {
                ...state,
                selectedStateData: payload
            }

        case SET_SELECTED_CITY_DATA:
            return {
                ...state,
                selectedCityData: payload
            }

        case SET_COUNTRY_REPORT_DATA:
            return {
                ...state,
                countryReportData: payload
            }

        case SET_REPORT_DEALER_DATA:
            return {
                ...state,
                dealerWiseData: payload
            }

        case SET_CONTRACTOR_REPORT_DATA:
            if (["CHILD", "CHILD_ALL"].includes(payload?.type)) {
                return {
                    ...state,
                    contractorWiseData: { ...state.contractorWiseData, child: payload.data }
                }
            } else if (["ASSOCIATE", "ASSOCIATE_ALL"].includes(payload?.type)) {
                return {
                    ...state,
                    contractorWiseData: { ...state.contractorWiseData, associate: payload.data }
                }
            }

        case SET_SEARCH_CERTIFICATE_DATA:
            return {
                ...state,
                searchedCertificateData: payload
            }

        case SET_CERTIFICATE_DATA:
            return { ...state, certificatesData: payload }

        case SET_CERTIFICATE_NAME:
            return { ...state, certificateName: payload }

        case SET_LOADER_FLAG:
            return { ...state, loader: payload }

        default:
            return state;
    }
}